import { useCurrentTouchpoint } from "hooks/api/use-current-touchpoint";
import { isEmailWriterJobRunning } from "utilities/email-writer-completion";

export const useIsEmailWriterGenerating = () => isEmailWriterJobRunning(useCurrentTouchpoint());
